export default "__VITE_ASSET__C7X$l7mh__"